import React from 'react';
import { ErrorState } from './States';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('TALKTO+ UI error boundary', error?.message || error);
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorState title="This view could not be rendered" message="Refresh or return to the previous view. No demo data was changed." onRetry={() => this.setState({ hasError: false })} />;
    }
    return this.props.children;
  }
}
